import { NgModule } from '@angular/core'
import { YesNoDialogModule } from './shared/dialogs/yes-no-dialog.module'
import { YesNoCancelDialogModule } from './shared/dialogs/yes-no-cancel-dialog.module'
import { SimpleDialogModule } from './shared/dialogs/simple-dialog.module'
import { HelpdeskDialogModule } from './core/layout/dialogs/helpdesk/helpdesk-dialog.module'
import { AddAttachmentDialogModule } from './domain/attachment/dialogs/add-attachment-dialog/add-attachment-dialog.module'
import { AddLinkAttachmentDialogModule } from './domain/attachment/dialogs/add-link-attachment-dialog/add-link-attachment-dialog.module'
import { ActionProgressDialogModule } from './shared/dialogs/action-progress-dialog/action-progress-dialog.module'
import { CuzkLoginDialogModule } from './domain/cadastral/dialogs/cuzk-login-dialog/cuzk-login-dialog.module'
import { DateSelectDialogModule } from './shared/dialogs/date-select-dialog/date-select-dialog.module'
import { EditDocxDialogModule } from './domain/attachment/dialogs/edit-docx-dialog/edit-docx-dialog.module'
import { EditScanDialogModule } from './domain/attachment/dialogs/edit-scan-dialog/edit-scan-dialog.module'
import { EditDocxTermsDialogModule } from './domain/attachment/dialogs/edit-docx-terms-dialog/edit-docx-terms-dialog.module'
import { InputTextDialogModule } from './shared/dialogs/input-text-dialog/input-text-dialog.module'

// App-wide modal dialogs that must be eagerly available for SimpleModalService.addModal()
// across the whole app. Aggregator only — no state/providers (those live in their own modules).
// Long-term: standalone components (DEV-330 Angular 17) eliminate the need for this aggregator.
const DIALOG_MODULES = [
    YesNoDialogModule,
    YesNoCancelDialogModule,
    SimpleDialogModule,
    HelpdeskDialogModule,
    AddAttachmentDialogModule,
    AddLinkAttachmentDialogModule,
    ActionProgressDialogModule,
    CuzkLoginDialogModule,
    DateSelectDialogModule,
    EditDocxDialogModule,
    EditScanDialogModule,
    EditDocxTermsDialogModule,
    InputTextDialogModule,
]

@NgModule({
    imports: DIALOG_MODULES,
    exports: DIALOG_MODULES,
})
export class AppDialogsModule {}
